import { useState } from "react";

type Props = {
  mediaHist: number;
  meta: number;
  sigma: number;
};

export default function InsightsProduto({ mediaHist, meta, sigma }: Props) {
  const [volumeKg, setVolumeKg] = useState<number>(0); // 🔹 produção em kg
  const [precoKg, setPrecoKg] = useState<number>(0);   // 🔹 preço em R$/kg

  const insights: string[] = [];

  const formatCurrency = (value: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);

  const formatNumber = (value: number) =>
    new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);


  if (sigma > 2) {
    insights.push("⚠️ Desvio elevado, risco de multa e inconsistência de processo.");
  }
  if (mediaHist > meta + 1) {
    insights.push("💸 Peso médio acima da meta → produto sendo entregue a mais.");
  }
  if (mediaHist < meta - 1) {
    insights.push("📉 Peso médio abaixo da meta → risco de multa por peso baixo.");
  }

  // excesso calculado em relação à meta
  const excessoPorUnidade = Math.max(0, mediaHist - meta); // g
  const excessoKg = excessoPorUnidade / 1000; // kg por unidade
  // custo total = excesso por unidade * volume produzido (kg) * preço do kg
  const custo = excessoKg * volumeKg * precoKg;

  return (
    <div className="bg-white p-4 rounded-xl border shadow-sm mt-4">
      <h3 className="font-semibold mb-2">🔍 Insights do Produto</h3>

      {/* Inputs manuais */}
      <div className="flex gap-4 mb-3 text-sm">
        <label className="flex flex-col">
          Volume produzido (kg)
          <input
            type="number"
            value={volumeKg}
            onChange={(e) => setVolumeKg(parseFloat(e.target.value) || 0)}
            className="border rounded px-2 py-1 mt-1 w-32"
          />
        </label>
        <label className="flex flex-col">
          Preço do kg (R$)
          <input
            type="number"
            step="0.01"
            value={precoKg}
            onChange={(e) => setPrecoKg(parseFloat(e.target.value) || 0)}
            className="border rounded px-2 py-1 mt-1 w-32"
          />
        </label>
      </div>

      {/* Alertas */}
      <ul className="text-sm list-disc list-inside space-y-1">
        {insights.length ? (
          insights.map((i, idx) => <li key={idx}>{i}</li>)
        ) : (
          <li>✅ Processo estável, sem alertas relevantes.</li>
        )}
      </ul>

      {/* Cálculo de custo */}
      <p className="mt-2 text-sm">
        💸 Custo estimado do excesso atual:{" "}
        <b>{formatCurrency(custo)}</b>{" "}
        (considerando {formatNumber(volumeKg)} kg produzidos a R${formatCurrency(precoKg)}/kg)
      </p>
    </div>
  );
}
